<div class="generate-payment">
  <div *ngIf="loading && !error" class="generate-payment__loading">
    <p>{{ 'GENERATE_PAYMENT.LOADING' | translate }}</p>
  </div>
  <div *ngIf="error" class="generate-payment__error">
    <p>{{ 'GENERATE_PAYMENT.ERROR' | translate }}</p>
  </div>
</div>
